import { getConfig } from "./runtimeConfig";

// AB#645437: read REACT_APP_ENVIRONMENT at runtime (window.ENV via env.js),
// falling back to build-time process.env for local dev. This lets the K8s env.js
// ConfigMap set the environment (shadow) so isDevelopment=false -> same-origin
// API URLs, instead of the local-dev http://<host>:6363 host.
export const isDevelopment = () => {
  const environment = getConfig("REACT_APP_ENVIRONMENT");
  return environment !== "production" && environment !== "shadow";
};

export default isDevelopment();
